<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin  --  -->
    <v-card class="box">
      <v-row fluid justify="center">
        <v-radio-group v-model="check_in_type" row>
          <v-radio label="Check-In by ID-Card" value="ICard"></v-radio>
          <v-radio label="Visitor Check-In" value="Visitor"></v-radio>
          <v-radio label="QR Code Check-In" value="QR"></v-radio>
        </v-radio-group>
      </v-row>
      <template v-if="check_in_type == 'ICard'">
        <v-row dense>
          <v-col cols="12" sm="3" md="3"></v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field outlined dense label="User-Id/PRno/Emp-code" type="text" v-model="user"></v-text-field>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-btn class="button" @click="fetchUser">Fetch</v-btn>
          </v-col>
        </v-row>
        <!-- org_basic_data --{{ org_basic_data }} <br /> -->
        <v-card class="box1" v-if="org_basic_data != null">
          <div class="header">
            <v-row>
              <!-- <v-col cols="12" sm="2" md="2"></v-col> -->
              <v-col cols="12" sm="3" md="3" align="left">
                <img :src="org_basic_data.trust_logo" alt="" style="width: 100%; height: 100%" />
              </v-col>
              <v-col cols="12" sm="9" md="9">
                <h3>
                  {{ org_basic_data.trust_name }}
                </h3>
                <span style="font-size: 16px">
                  {{ org_basic_data.school_name }} <br />
                </span>
                <span>{{ org_basic_data.address }}</span><br />
                <span v-html="org_basic_data.line1"></span><br />
                <span v-html="org_basic_data.line2"></span><br />
              </v-col>
            </v-row>
          </div>
          <v-row dense v-if="visitor_photo != null">
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col cols="12" sm="3" md="3">
              <v-img style="width: 250px; height: 155px" class="shrink mr-2" :src="awspath + visitor_photo"></v-img>
            </v-col>
          </v-row>
          <v-row dense v-if="visitor_username != null">
            <v-col cols="12" sm="1" md="1"></v-col>

            <v-col cols="12" sm="11" md="11">
              <center>
                <span style="font-weight: 500">Emp Code / PRN / User ID: {{ visitor_username }}</span>
                <br />
                <span style="font-weight: 500">{{ visitor_name }}</span> <br />
                <span style="font-weight: 500">{{ visitor_usertype }}</span>
              </center>
            </v-col>
          </v-row>
        </v-card>
        <!-- <v-datetime-picker
        dateFormat="dd-MM-yyyy"
        timeFormat="hh:mm aa"
        label="Check-In Date"
        v-model="check_in_dt"
      ></v-datetime-picker> -->
        <template v-if="!hide_card_check_in">
          <v-row dense>
            <v-col cols="12" sm="3" md="3"></v-col>
            <v-col cols="12" sm="6" md="6">
              <p><v-icon color="error">*</v-icon><b>Visit Purpose</b></p>
              <v-text-field outlined type="text" v-model="purpose" label="Visit Purpose"></v-text-field>
            </v-col>
          </v-row>

          <!-- shiv code -->

          <v-row dense>
            <v-col cols="12" sm="3" md="3"></v-col>

            <v-col cols="12" sm="4" md="4" v-if="checkbox1 == false">
              <p><v-icon color="error">*</v-icon><b>Whom To Contact</b></p>
              <v-autocomplete color="#0F2027" dense rounded required v-model="sel_host" :items="host"
                item-text="inst_name" item-value="id" label="Host" outlined />
              <!-- {{ sel_host }} -->
              <!-- <v-btn class="button" @click="cardCheckIn">Check-In</v-btn> -->
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="3" md="3"></v-col>

            <v-col cols="12" sm="2" md="2">
              <v-checkbox v-model="checkbox1" label="Host Not in List"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4" v-if="checkbox1 == true">
              <v-text-field outlined dense type="text" v-model="whom_to_contact" label="Whom to contact"></v-text-field>
            </v-col>
          </v-row>
          <v-row dense justify="center">
            <v-btn class="button" :disabled="isSaveButtonDisabled" @click="cardCheckIn">Check-In</v-btn>
          </v-row>
        </template>
        <!-- shoiv code end -->
        <!-- vikas sir code -->
        <!-- <div>
             <v-text-field
          outlined
          dense
          type="text"
          v-model="whom_to_contact"
          label="Whom to contact"
        ></v-text-field>
        <v-autocomplete
          color="#0F2027"
          dense
          rounded
          required
          v-model="sel_host"
          :items="host"
          item-text="inst_name"
          item-value="id"
          label="Host"
          outlined
        />
        {{ sel_host }}
        <v-btn @click="cardCheckIn">Check-In</v-btn>
        </div> -->
      </template>

      <!-- check-in for visitors -->
      <template v-if="check_in_type == 'Visitor'">
        <v-row dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="1" md="1"><span style="font-weight: 500"> Step 1</span>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_visitor" :items="visitors_list"
              item-text="visitor_mob_name" @change="checkPreApprovedVisitor" return-object
              label="Search visitors by mobile no And Name" outlined />
          </v-col>

          <v-col cols="12" sm="1" md="1" align="right">
            <!-- <v-btn class="button" @click="fetchVisitors">
              <v-icon>mdi-cloud-refresh</v-icon></v-btn
            > -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="button" v-bind="attrs" v-on="on" @click="fetchVisitors">
                  <v-icon>mdi-cloud-refresh</v-icon></v-btn>
              </template>
              <span> Reload Visitor </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="1" md="1">
            <!-- <v-btn class="button" @click="addVisitor"
              ><v-icon>mdi-account-plus</v-icon></v-btn
            > -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="button" v-bind="attrs" v-on="on" @click="addVisitor">
                  <v-icon>mdi-account-plus</v-icon></v-btn>
              </template>
              <span> Add Visitor </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="sel_visitor != null" dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="1" md="1"></v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Visitor Name</b></p>

            <v-text-field outlined dense v-model="sel_visitor.visitor_name" readonly filled></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Visitor Address</b></p>

            <v-text-field outlined dense v-model="sel_visitor.visitor_address" readonly filled></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="1" md="1">
            <span style="font-weight: 500"> Step 2</span>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <a href="/capture-photo" target="_blank">Capture Photo</a>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="1" md="1"><span style="font-weight: 500"> Step 3</span>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-btn class="button" @click="getPhoto">Get Captured Photo
            </v-btn></v-col>
          <v-col cols="12" sm="3" md="3" v-if="photo_path && photo_name">
            <v-img :src="awspath + photo_path + photo_name" style="width: 150px; height: 150px;"
              v-if="photo_path != null" />
          </v-col>
          <!-- <v-col cols="12" sm="2" md="2" v-if="schedule_visit_info && schedule_visit_info.old_photo_visitor != null">
            <v-img :src="awspath + schedule_visit_info.old_photo_visitor" style="width: 150px; height: 150px;" />
          </v-col> -->



          <v-col cols="12" sm="2" md="2" align="left">
            <v-btn class="button" @click="clearPhoto">Clear Captured Photo
            </v-btn>
          </v-col>
        </v-row>
        <div v-if="pre_approved_flag">
          <v-row dense>
            <v-col cols="12" sm="2" md="2"></v-col>
            <v-col cols="12" sm="1" md="1"><span style="font-weight: 500"> Step 4 </span>
            </v-col>
            <!-- Step 4. [Pre-approved] -->
            <v-col cols="12" sm="3" md="3">
              <p><b>Visit Purpose</b></p>

              <v-text-field outlined dense v-model="schedule_visit_info.vs_purpose" readonly filled></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <p><b>Whom To Contact </b></p>

              <v-text-field outlined dense v-model="schedule_visit_info.vs_whom_to" readonly filled></v-text-field>
            </v-col>

            <!-- {{ schedule_visit_info }}||{{ vsp_id }} -->
          </v-row>
          <v-row dense justify="center">
            <!-- <v-col cols="12" sm="3" md="3"> -->
            <v-btn class="button" @click="checkInPreApproved">Check-In</v-btn>
            <!-- </v-col> --> </v-row><br />
          <v-row dense justify="center">
            <a v-bind:href="visitor_epass_url">{{ visitor_epass_url }}</a>
            <!-- <span> {{ visitor_epass_url }}</span> <br /> -->
            <br />
          </v-row>
          <center>
            <qrcode-vue :value="visitor_epass_url" v-if="visitor_epass_url" :size="150" level="H" />
          </center>
        </div>
        <div v-else-if="sel_visitor != null">
          <v-row>
            <v-col cols="">
              <v-row dense>
                <v-col cols="12" sm="2" md="2"></v-col>
                <v-col cols="12" sm="1" md="1"><span style="font-weight: 500"> Step 4 </span>
                </v-col>
              </v-row>
              <!-- Step 4. [Walk-In] {{ walkin_whom_flag }} || {{ sel_visitor }} ||
            walkin_visitor_found &nbsp;{{ walkin_visitor_found }} -->
              <template v-if="!walkin_visitor_found">
                <v-row dense>
                  <v-col cols="12" sm="2" md="2"></v-col>
                  <v-col cols="12" sm="8" md="8">
                    <p><v-icon color="error">*</v-icon><b>Visit Purpose</b></p>
                    <v-textarea auto-grow outlined name="input-7-4" v-model="walkin_purpose"
                      label="Enter Purpose of visit"></v-textarea>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="2" md="2"></v-col>

                  <v-col cols="12" sm="4" md="4" v-if="walkin_whom_flag == false">
                    <p>
                      <v-icon color="error">*</v-icon><b>Whom To Contact</b>
                    </p>
                    <v-autocomplete color="#0F2027" dense rounded :items="host_list" item-text="inst_name"
                      item-value="id" label="Select Host" outlined persistent-hint hint="Please Select Host"
                      v-model="walkin_host" />
                  </v-col>
                  <!-- {{ walkin_host }} -->
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="2" md="2"></v-col>

                  <v-col cols="12" sm="4" md="4">
                    <v-checkbox v-model="walkin_whom_flag" label="Host not in List"></v-checkbox>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" v-if="walkin_whom_flag == true">
                    <!-- <p><v-icon color="error">*</v-icon><b>Whom To Contact</b></p> -->

                    <v-text-field outlined dense type="text" label="Whom To Contact"
                      v-model="walkin_whomto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="center" v-if="walkin_vvid == null">
                  <v-btn class="info ma-2" v-if="walkin_whom_flag" @click="saveWalkInVisit('Approve')">Direct
                    Check-IN</v-btn>
                  <v-btn class="info ma-2" v-if="!walkin_whom_flag" @click="saveWalkInVisit('Approve')">Direct
                    Check-IN</v-btn>

                  <v-btn class="info ma-2" v-if="!walkin_whom_flag" @click="saveWalkInVisit('Un-Approve')">Check-IN by
                    Approval</v-btn>
                </v-row>
              </template>
              <template v-else>
                <v-row dense>
                  <v-col cols="12" sm="2" md="2"></v-col>
                  <v-col cols="12" sm="4" md="4">
                    <!-- <span style="font-weight: 500"> Walk-In Visitor Found</span> -->
                  </v-col>
                </v-row>
              </template>
              <template v-if="walkin_approval_flag || walkin_visitor_found">
                <!-- new code 15/06 -->
                <v-row dense v-if="walkin_visitor_approval == 'Yes'" justify="center">
                  <!-- <span style="font-weight: 500; color: green">
                    Visitor is Approve</span
                  > -->
                  <span style="font-weight: 500; color: green">
                    Visitor Approved</span>
                </v-row>
                <v-row dense v-if="walkin_visitor_rejected == 'Yes'" justify="center">
                  <!-- <span style="font-weight: 500; color: red">
                    Visitor is Rejected</span
                  > -->
                  <span style="font-weight: 500; color: red">
                    Visitor Rejected</span>
                </v-row>
                <v-row justify="center"> <v-col cols="12" sm="4" md="4" align="center">
                    <span style="font-weight: 500">
                      Visitor Approved / Rejected by :
                    </span>
                  </v-col></v-row>
                <v-row dense justify="center">

                  <v-col cols="12" sm="4" md="4">
                    <span style="font-weight: 500">
                      <!-- Visitor Approved / Rejected by : -->
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="4" align="center" v-if="walkin_visitor_approval == 'Yes'">
                    <span style="font-weight: 500" v-if="walkin_visitor_approved_by">
                      {{ walkin_visitor_approved_by }}::{{ visitor_approved_rejected_by_mob }}
                      <!-- <a v-bind:href="walkin_visitor_approved_by">{{ walkin_visitor_approved_by }}</a> -->
                      <!-- {{ walkin_visitor_approved_by }} -->
                    </span>
                    <!-- {{ walkin_visitor_approval_by }} -->
                  </v-col>
                  <v-col cols="12" sm="4" md="4" align="center" v-if="walkin_visitor_rejected == 'Yes'">
                    <span style="font-weight: 500" v-if="walkin_visitor_approved_by">
                      {{ walkin_visitor_approved_by }}::{{ visitor_approved_rejected_by_mob }}
                      <!-- <a v-bind:href="walkin_visitor_approved_by">{{ walkin_visitor_approved_by }}</a> -->
                      <!-- {{ walkin_visitor_approved_by }} -->
                    </span>
                  </v-col>
                  <v-col cols="12" sm="4" md="4"></v-col>
                </v-row>
                <!-- new code 15/06 end -->
                <center>
                  <a v-bind:href="walkin_visitor_epass_url">{{ walkin_visitor_epass_url }}</a>

                  <br /><br />
                  <qrcode-vue :value="walkin_visitor_epass_url" v-if="walkin_visitor_epass_url" :size="150" level="H" />
                </center>

                <v-btn @click="approveWalkinVisitor" v-if="walkin_vvid != null && walkin_visitor_approval == 'No'"
                  class="info">Approve Walk-In</v-btn>
              </template>
            </v-col>
          </v-row>
        </div>
      </template>
      <!-- QR code check-in -->
      <template v-if="check_in_type == 'QR'">
        <v-row dense>
          <v-col cols="12" sm="3" md="3"></v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field outlined autofocus dense label="Enter URL" type="url" v-model="qrURL"
              @keydown="handleKeyDown"></v-text-field>
          </v-col>

          <v-col cols="12" sm="3" md="3">
            <v-btn class="button" @click="openURL">Go</v-btn>
          </v-col>
        </v-row>
        <center>
          <p>Entered URL: {{ qrURL }}</p>
        </center>
      </template>
    </v-card>
  </div>
</template>

<script>
// import DatetimePicker from "vuetify-datetime-picker";
import QrcodeVue from "qrcode.vue";
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {

  components: {
    QrcodeVue,
    Breadcrumbs
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    awspath: null,
    check_in_type: null,
    ////////////////////
    checkbox1: false,

    user: null,
    org_basic_data: null,
    visitor_username: null,
    visitor_photo: null,
    visitor_name: null,
    visitor_usertype: null,
    host: null,
    hide_card_check_in: true,
    /////////////////
    check_in_dt: null,
    purpose: null,
    sel_host: null,
    whom_to_contact: null,
    //////
    photo_path: null,
    photo_name: null,
    ////////////
    visitors_list: null,
    sel_visitor: null,
    ////////////////////
    pre_approved_flag: false,
    vsp_id: null,
    schedule_visit_info: null,
    host_list: null,
    ////
    visitor_epass_url: null,
    qrURL: null,
    //////////////////
    visitor_approved_rejected_by: null,
    walkin_purpose: null,
    walkin_whomto: null,
    walkin_host: null,
    walkin_whom_flag: false,
    walkin_visitor_approval: false,
    walkin_visitor_rejected: false,
    walkin_visitor_approved_by: null,
    visitor_approved_rejected_by_mob: null,
    walkin_approval_flag: false,
    walkin_visitor_found: false,
    walkin_visitor_epass_url: null,
    walkin_vvid: null,
  }),
  mounted() {
    localStorage.setItem("photo_path", "");
    localStorage.setItem("photo_name", "");
    this.fetchVisitors();
  },
  computed: {
    isSaveButtonDisabled() {
      return !(this.purpose && (this.sel_host || this.whom_to_contact));
    },
  },
  created() {
    this.awspath = localStorage.getItem("awspath");
  },
  methods: {
    clearPhoto() {
      this.photo_path = null;
      this.photo_name = null;
    },
    addVisitor() {
      //this.$router.push({ name: "admin-add-visitor", target: "_blank" });
      let routeData = this.$router.resolve({ name: "admin-add-visitor" });
      window.open(routeData.href, "_blank");
    },
    getPhoto() {
      this.photo_path = localStorage.getItem("photo_path");
      this.photo_name = localStorage.getItem("photo_name");
      //  console.log(" this.photo_path", this.photo_path)
      if (this.photo_path == "" || this.photo_path == undefined) {
        this.showSnackbar("red", "Please capture photo first.");
        this.photo_path = null;
        this.photo_name = null;
      }
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() + 1
        }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////
    fetchVisitors() {
      axios
        .post("/visitorManagement/getAllVisitors")
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.visitors_list = res.data.visitors_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    approveWalkinVisitor() {
      const formdata = {
        walkin_vvid: this.walkin_vvid,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/approveWalkinVisitor", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.walkin_visitor_approval = res.data.visitor_approval;
            this.walkin_visitor_approved_by = res.data.visitor_approved_by;
            this.visitor_approved_rejected_by_mob = res.data.visitor_approved_by_mob;

            this.walkin_visitor_epass_url = res.data.walkin_visitor_epass_url;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    saveWalkInVisit(type) {
      //check purpose, whomto
      const formdata = {
        walkin_visitor_id: this.sel_visitor.visitor_id,
        walkin_purpose: this.walkin_purpose,
        walkin_whomto: this.walkin_whomto,
        walkin_host_id: this.walkin_host,
        visitor_photo_path: this.photo_path,
        visitor_photo_name: this.photo_name,
        type: type,
      };
      this.overlay = true;
      console.log("sel_visitor", this.sel_visitor);
      axios
        .post("/visitorManagement/saveWalkInVisit", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.walkin_visitor_approval = res.data.visitor_approval;

            this.walkin_visitor_approved_by =
              res.data.visitor_approved_rejected_by;
            this.walkin_visitor_rejected = res.data.visitor_rejected; // new added 15/06
            this.visitor_approved_rejected_by_mob = res.data.visitor_approved_rejected_by_mob;

            this.walkin_approval_flag = true;
            this.walkin_visitor_epass_url = res.data.walkin_visitor_epass_url;
            this.walkin_vvid = res.data.walkin_vvid;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    fetchUser() {
      const formdata = {
        user: this.user,
      };
      axios
        .post("/visitorManagement/initCheckIn", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.org_basic_data = res.data.org_basic_data;
            this.visitor_username = res.data.visitor_username;
            this.visitor_photo = res.data.visitor_photo;
            this.visitor_name = res.data.visitor_name;
            this.visitor_usertype = res.data.visitor_usertype;
            this.host = res.data.host;
            this.hide_card_check_in = res.data.hide_card_check_in;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.hide_card_check_in = res.data.hide_card_check_in;
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    openURL() {
      if (this.qrURL) {
        window.open(this.qrURL, '_blank');
      }
      else {
        alert("Invalid URL or URL is empty")
      }
    },
    async handleKeyDown(event) {
      // Check if the key pressed is Enter (key code 13)
      if (event.key === 'Enter') {
        // alert(this.qrURL)
        window.open(this.qrURL, "_blank");

      }
    },
    cardCheckIn() {
      //  let form_check_in_dt = this.formatDate(this.check_in_dt, true);
      const formdata = {
        visitor_username: this.visitor_username,
        purpose: this.purpose,
        sel_host_id: this.sel_host,
        whom_to_contact: this.whom_to_contact,
        // form_check_in_dt:form_check_in_dt,
      };
      axios
        .post("/visitorManagement/saveCardCheckIn", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    init_walkin() {
      this.walkin_purpose = null;
      this.walkin_whomto = null;
      this.walkin_host = null;
      this.walkin_whom_flag = false;
      this.walkin_visitor_approval = false;
      this.walkin_visitor_rejected = false;
      this.walkin_visitor_approved_by = null;
      this.visitor_approved_rejected_by_mob = null;
      this.walkin_approval_flag = false;
      this.walkin_visitor_found = false;
      this.walkin_vvid = null;
    },
    checkPreApprovedVisitor() {
      this.init_walkin();
      this.photo_path = null;
      this.photo_name = null;
      this.pre_approved_flag = false;
      this.schedule_visit_info = null;
      this.vsp_id = null;
      const formdata = {
        visitor_id: this.sel_visitor.visitor_id,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/checkPreApprovedVisitor", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
            this.schedule_visit_info = res.data.schedule_visit_info;
            this.vsp_id = res.data.vsp_id;
            this.pre_approved_flag = true;
            //
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.host_list = res.data.host_list;
          this.walkin_visitor_found = false;
          if (res.data.walkin_visitor_found) {
            this.walkin_visitor_found = true;
            this.walkin_visitor_approval = res.data.visitor_approval;
            this.walkin_visitor_rejected = res.data.visitor_rejected;
            this.walkin_visitor_approved_by =
              res.data.visitor_approved_rejected_by;
            this.visitor_approved_rejected_by_mob =
              res.data.visitor_approved_rejected_by_mob;
            this.walkin_visitor_epass_url = res.data.walkin_visitor_epass_url;
            this.walkin_vvid = res.data.walkin_vvid;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    }, //checkInPreApproved
    checkInPreApproved() {
      const formdata = {
        vsp_id: this.vsp_id,
        visitor_photo_path: this.photo_path,
        visitor_photo_name: this.photo_name,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/checkInPreApproved", formdata)
        .then((res) => {
          console.log("res:", res.data);
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.showSnackbar("green", res.data.snackbar);
            this.visitor_epass_url = res.data.visitor_epass_url;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    }, //
  },
};
</script>

<style scoped>
.box1 {
  background-color: white !important;
  /* margin: 8px !important;
  padding: 8px; */
  border: 2px solid #8360c3 !important;
  width: 45%;
  margin-left: 28%;
}

.header span {
  font-weight: 500;
  font-size: 13px;
}

.button {
  margin: 0 !important;
}
</style>